import { Injectable } from '@angular/core';
import { BehaviorSubject, of } from 'rxjs';
import { CatalogoService } from './catalogo.service';
import { catchError, tap } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class CarritoService {
  private carritoSubject = new BehaviorSubject<any>(null);
  public carrito$ = this.carritoSubject.asObservable();

  constructor(private catalogoService: CatalogoService) {}

  cargarCarrito(): void {
    const user = localStorage.getItem('userPlataformaTY');
    if (!user) return;

    this.catalogoService.verCarrito().pipe(tap((data:any) => {
        this.carritoSubject.next(data);
        localStorage.setItem('toyocarrito', JSON.stringify(data));
      }),
      catchError(error => {
        console.error(error);
        return of(null);
      })
    ).subscribe();
  }

  getCantidadProductos(): number {
    const carrito = this.carritoSubject.getValue();
    return carrito?.detalle_productos?.length || 0;
  }
}
